import React from 'react';

const LOGO_URL = '/woss-publishing-assets/images/woss-publishing-logo-white.svg';

// The client portal is now a separate Next.js app/Cloud Run service, not a
// /auth/login is routed by the load balancer's URL map to the separate
// Next.js portal Cloud Run service, not to this React app — plain <a>,
// not a react-router <Link>, since it's a full cross-app navigation.
const CLIENT_PORTAL_URL = '/auth/login';

/* Arrow icon used in the PORTAL button — matches template button_icon */
const ArrowIcon = () => (
  <div className="button_icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 11 9" fill="none" className="icon-1x1-sm-minus">
      <path d="M5.76953 8.91406L5.00391 8.14844L6.44629 6.71289C6.7334 6.42578 7.03418 6.13411 7.34863 5.83789C7.66309 5.53711 7.9707 5.24772 8.27148 4.96973C8.06185 4.97884 7.85221 4.98796 7.64258 4.99707C7.43294 5.00163 7.22331 5.00391 7.01367 5.00391H0V3.91016H7.01367C7.22331 3.91016 7.43294 3.91471 7.64258 3.92383C7.85221 3.92839 8.06185 3.93522 8.27148 3.94434C7.9707 3.66634 7.66309 3.37923 7.34863 3.08301C7.03418 2.78223 6.7334 2.48828 6.44629 2.20117L5.00391 0.765625L5.76953 0L10.2266 4.45703L5.76953 8.91406Z" fill="currentColor" />
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 11 9" fill="none" className="icon-1x1-sm-minus">
      <path d="M5.76953 8.91406L5.00391 8.14844L6.44629 6.71289C6.7334 6.42578 7.03418 6.13411 7.34863 5.83789C7.66309 5.53711 7.9707 5.24772 8.27148 4.96973C8.06185 4.97884 7.85221 4.98796 7.64258 4.99707C7.43294 5.00163 7.22331 5.00391 7.01367 5.00391H0V3.91016H7.01367C7.22331 3.91016 7.43294 3.91471 7.64258 3.92383C7.85221 3.92839 8.06185 3.93522 8.27148 3.94434C7.9707 3.66634 7.66309 3.37923 7.34863 3.08301C7.03418 2.78223 6.7334 2.48828 6.44629 2.20117L5.00391 0.765625L5.76953 0L10.2266 4.45703L5.76953 8.91406Z" fill="currentColor" />
    </svg>
  </div>
);

/* Hamburger icon (open) */
const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24" fill="none" className="menu_button-icon">
    <path fillRule="evenodd" clipRule="evenodd" d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM3 12C3 11.5858 3.33579 11.25 3.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H3.75C3.33579 12.75 3 12.4142 3 12ZM11.25 17.25C11.25 16.8358 11.5858 16.5 12 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H12C11.5858 18 11.25 17.6642 11.25 17.25Z" fill="currentColor" />
  </svg>
);

/* Close icon (x) */
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24" fill="none" className="menu_button-icon is-close">
    <path d="M20.25 3.75L3.75 20.25" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M20.25 20.25L3.75 3.75" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

export default function Header() {
  return (
    <div
      data-animation="over-left"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="nav w-nav"
    >
      <div className="nav_component">
        <div className="padding-global">
          <div className="nav_container">
            {/* Logo */}
            <a href="/#home" className="nav_brand w-nav-brand" aria-label="Woss Publishing">
              <img
                src={LOGO_URL}
                alt="Woss Publishing"
                className="wp-nav-logo"
              />
            </a>

            {/* Desktop nav menu */}
            <nav role="navigation" className="nav_menu-wrap w-nav-menu">
              <div className="nav_menu-content">
                <div className="nav_menu">
                  <a href="/#home"      className="nav_menu_text w-nav-link">Home</a>
                  <a href="/#who-we-are" className="nav_menu_text w-nav-link">Who We Are</a>
                  <a href="/#roster"    className="nav_menu_text w-nav-link">Roster</a>
                  <a href="/#synch"     className="nav_menu_text w-nav-link">Synch</a>
                </div>
                {/* Mobile menu CTA area */}
                <div className="nav_cta-mobile">
                  <a href="mailto:global@wosspublishing.com" className="footer_contact-email">
                    <span data-load-text="">global@wosspublishing.com</span>
                  </a>
                  <div style={{ marginTop: '1.25rem' }}>
                    <a href={CLIENT_PORTAL_URL} className="button w-inline-block">
                      <span className="text-size-sm">Portal</span>
                      <ArrowIcon />
                    </a>
                  </div>
                </div>
              </div>
            </nav>

            {/* Desktop PORTAL button */}
            <div className="overflow-hidden">
              <div className="nav_cta">
                <a href={CLIENT_PORTAL_URL} className="button w-inline-block">
                  <span className="text-size-sm">Portal</span>
                  <ArrowIcon />
                </a>
              </div>
            </div>

            {/* Mobile hamburger */}
            <div className="menu_button-mobile w-nav-button" aria-label="Toggle menu">
              <HamburgerIcon />
              <CloseIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
